import styled from 'styled-components';
import tw from 'tailwind.macro';
import { math, rem } from 'polished';

import { theme } from '../../tailwind.config.js';

export const Form = styled.form`
  input[type='email'] {
    ${tw`mb-24 pb-12 font-text text-base text-black w-full`};
    border-bottom: 1px solid ${theme.colors.black};
    line-height: ${math('22/17')};

    &::placeholder {
      ${tw`text-grey`};
      opacity: 1;
    }

    &:-ms-input-placeholder {
      ${tw`text-grey`};
    }

    &::-ms-input-placeholder {
      ${tw`text-grey`};
    }

    &:focus {
      ${tw`bg-transparent outline-none`};
    }
  }

  input[type='checkbox'] {
    ${tw`inline-block`};
  }

  label {
    ${tw`inline-block mb-24`};
  }
`;
